import React, { useState } from "react";
import "./StudentTestimonials.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from '../about/PageHeader';

const Icons = {
  ImagePlaceholder: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.5" y="5.5" width="17" height="13" rx="3" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="9" cy="10" r="1.6" fill="currentColor" />
      <path
        d="M6.5 16l3.2-3.2a1.2 1.2 0 0 1 1.7 0l1.8 1.8 2.4-2.4a1.2 1.2 0 0 1 1.7 0L19 14"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Quote: () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M10 11H6.75A1.75 1.75 0 0 0 5 12.75V16a2 2 0 0 0 2 2h1.5a2.5 2.5 0 0 0 2.5-2.5V9.75A3.75 3.75 0 0 0 7.25 6"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 11h-3.25A1.75 1.75 0 0 0 14 12.75V16a2 2 0 0 0 2 2h1.5a2.5 2.5 0 0 0 2.5-2.5V9.75A3.75 3.75 0 0 0 16.25 6"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
};

const testimonials = [
  {
    role: "Software Engineer at Capgemini",
    name: "Uzma Khan",
    batch: "MCA (2020-2022)",
    image: "/Testimonials/WhatsApp-Image-2021-10-27-at-10.19.17.jpeg",
    paragraphs: [
      "I, Ms. Uzma Khan would like to appreciate TIMSCDR for helping me in each step of my master's career, and especially pleased to have the opportunity to share some of my thoughts and observations about our college. These past few months have acted as a stepping stone for us in understanding how to achieve our goals during this difficult situation to our college managed to give us what is assured.",
      "They make sure to provide us all the necessary information required I really appreciate their level of effort and patience during virtual learning. Our personal assigned mentors helped us in all the aspects of difficulties. The placement division orchestrates their placement activities with an efficient process of getting students trained for jobs from technical skills, soft skills to weekly aptitude round tests.",
      "I would like to thank the Director, HOD and the entire team of TIMSCDR for pushing us to improve our knowledge and perception better than before. Looking forward to opportunities and internships to achieve my goals. Apart from everything TIMSCDR provides us a great platform for skills enhancement and it has been adding a great learning experience while pursuing my respected degree."
    ]
  },
  {
    role: "Postgraduate Alumni",
    name: "Tausif Khan",
    batch: "MCA (2020 - 2022)",
    image: "/Testimonials/WhatsApp-Image-2021-10-27-at-10.18.39-165x165.jpeg",
    paragraphs: [
      "TIMSCDR is a good institute with better career opportunities and improving placements year by year, Teaching Methodologies and arranging Modern equipment for better understanding of things in practical. This institution has always supported their students for doing something good. Each department of this institute have honest and dedicated faculty."
    ]
  },
  {
    role: "SDE@MountBlue Technologies",
    name: "Rahul Gupta",
    batch: "MCA (2019-2022)",
    image: "/Testimonials/rahul-gupta-2-165x165.jpeg",
    paragraphs: [
      "I would like to express my sincere gratitude to TIMSCDR for helping me at each and every step of my professional career. The Institute provided me the best possible platform and infrastructure to pursue my career interest. The expert faculty made me industry ready, while the placement training helped me enhance my technical as well as soft skills.",
      "I was able to get an internship opportunity through college which made me stand out from others. It has given me amazing opportunities to learn, grow and explore my skills. I would like to thank TIMSCDR and all faculties and staff for making me a better person."
    ]
  },
  {
    role: "System Engineer @ TCS",
    name: "Ashish Jaiswal",
    batch: "MCA (2019-2022)",
    image: "/Testimonials/ashish-jaswal-165x165.jpeg",
    paragraphs: [
      "At TIMSCDR, I realised a well-known proverb by 'Chris Grosser', \"Opportunities don't happen, You create them\". At TIMSCDR, we are offered numerous opportunities to learn well as to earn. It's upto you to extract the most out of them.",
      "At TIMSCDR, I got the opportunity to participate in serveral competitions conducted by NASA, Nasscom, Microsoft, AICTE, and so many inter College and intra college competition, which gave an exposure, not to forget the important workshops/ conferences we got to attend.",
      "Apart from that TIMSCDR aslo provided an opportunity to work as intern at IIT Mumbai which gave me a whole new experience and understanding. The faculty is like family and the Instiutue is like second home. The mentor we get assigned from college guides at every step and the director ma'am is like a caring guardian, who always takes care of us and takes our feedbacks seriously. Overall I can't forget this TIMSCDR family ever."
    ]
  },
  {
    role: "Associate Trainee at Chenoa Information and Software Services Private Limited",
    name: "Ms. Mayuri Tiwari",
    batch: "MCA (2018-2021)",
    image: "/Testimonials/mayuri-tiwari-165x165.jpeg",
    paragraphs: [
      "Thank you for shaping me into the adult that I am today and for giving me professors that truly cared about my success and didn't see me as a number. Thank you for providing me with lifelong mentors who I know I could always go to at any point in my career.",
      "Thank you for opening doors to so many opportunities and thank you for setting me up for success. Thank you for being the place where I discovered myself. Thank you for truly caring about the well-being of the students."
    ]
  },
  {
    role: "Senior Consultant Advisory at PricewaterhouseCoopers (PwC) India Private Limited",
    name: "Mr. Brijesh Sah",
    batch: "MCA (2006-2009)",
    image: "/Testimonials/testimonial1-165x165.jpg",
    paragraphs: [
      "TIMSCDR had been a great contributor towards the development of my career. The entire staff was very supportive and approachable with an attitude of being ever ready to help. Class room trainings along with real-time case studies, industry best practices with examples and improving communication skills with constant interactions, were extremely useful.",
      "The Green campus and infrastructure of the college is one of the finest in Mumbai. The computer labs were well equipped and available all the time. One could study in the library beyond the class timings. I am thankful to TIMSCDR for the creation of favourable conditions for successful personal and professional growth, wonderful professors and unforgettable years."
    ]
  },
  {
    role: "Tech Head at GETPARKING (Play Time Media PVT. LTD.)",
    name: "Mr. Rajiv Singh",
    batch: "MCA (2006-2011)",
    image: "/Testimonials/testimonial2-165x165.jpg",
    paragraphs: [
      "TIMSCDR is one of the important base in my life. I owe my current career and progress to this esteemed institution which played an active role in shaping my personality. It provides the necessary freedom to explore your interest along with studies.",
      "A practical approach towards life and work is what I gained through this institute. It's easier said than done had it not been to the teachers and staff who took up the responsibility of shaping my career. In all its a fun place to work, play and study."
    ]
  },
  {
    role: "Quality Assurance Engineer at FIS GLOBLE, U.S.A",
    name: "Mr. Roidon Rodrigues",
    batch: "MCA (2013-2016)",
    image: "/Testimonials/testimonial4-165x165.jpg",
    paragraphs: [
      "TIMSCDR's three years gave me ample of opportunities where I was able to grow and develop my skills. These skills were not only academic based but also skills required to have a successful career. I had participated in the tech fest as a core committee member and during that time I was exposed to a leadership role which I believe has had a huge impact in my career today.",
      "These skills and other such skills which I picked up along the way with the guidance and support from my teachers at Thakur has helped me to mentor new grads at my work place. I will always be thankful for what positive encouragement and support I received during my time here. Thank you."
    ]
  },
  {
    role: "Engineer at Fractal Analytics, Mumbai",
    name: "Mr. Muzammil Jafferi",
    batch: "MCA (2014-2017)",
    image: "/Testimonials/testimonial3-165x165.jpg",
    paragraphs: [
      "I am thankful to all my Teachers of TIMSCDR whose support were like parents in all the situation throughout my MCA career.Taking admission in TIMSCDR was a perfect decision for me.",
      "TIMSCDR provides a great platform for learning and has helped me to develop a positive attitude towards my life & decision-making capacity in all aspects of my career. TIMSCDR will change your experience and shape you as a responsible individual."
    ]
  }
];

const StudentTestimonials = () => {
  const [expandedCards, setExpandedCards] = useState({});

  const toggleCard = (index) => {
    setExpandedCards((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <>
      <Navbar />
      <PageHeader
        title="Alumni Testimonials"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'Alumni Testimonials' }]}
      />
      <div className="st-app">
        <div className="st-container">
          <div className="st-testimonials">
            {testimonials.map((testimonial, index) => {
              // Lifted the state logic so we can apply the expanded class to the <article>
              const isExpanded = Boolean(expandedCards[index]);
              const previewParagraphs = testimonial.paragraphs.slice(0, 1);
              const visibleParagraphs = isExpanded ? testimonial.paragraphs : previewParagraphs;

              return (
                <article 
                  className={`st-testimonial-card ${isExpanded ? 'st-testimonial-card--expanded' : ''}`} 
                  key={`${testimonial.name}-${index}`}
                >
                  <div className="st-testimonial-image-wrapper" aria-hidden="true">
                    {testimonial.image ? (
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="st-testimonial-image"
                      />
                    ) : (
                      <div className="st-testimonial-image-placeholder">
                        <div className="st-placeholder-kicker">
                          <Icons.ImagePlaceholder />
                          <span>Image Space</span>
                        </div>
                        <span className="st-placeholder-name">{testimonial.name}</span>
                      </div>
                    )}
                  </div>
                  <div className="st-testimonial-content">
                    <div className="st-testimonial-header">
                      <h2 className="st-testimonial-role">{testimonial.role}</h2>
                      <div className="st-quote-icon">
                        <Icons.Quote />
                      </div>
                    </div>
                    <div className="st-testimonial-text">
                      {visibleParagraphs.map((paragraph, paragraphIndex) => (
                        <p key={paragraphIndex}>{paragraph}</p>
                      ))}
                    </div>
                    {testimonial.paragraphs.length > 1 && (
                      <button
                        type="button"
                        className="st-read-more-btn"
                        onClick={() => toggleCard(index)}
                        aria-expanded={isExpanded}
                      >
                        {isExpanded ? "Show less" : "Read more"}
                      </button>
                    )}
                    <div className="st-testimonial-footer">
                      <p className="st-testimonial-name">
                        {"\u2014"} {testimonial.name}, {testimonial.batch}
                      </p>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default StudentTestimonials;